import { render } from "./ChannelView.vue?vue&type=template&id=79d17fc4&scoped=true"
import script from "./ChannelView.vue?vue&type=script&lang=js"
export * from "./ChannelView.vue?vue&type=script&lang=js"

import "./ChannelView.vue?vue&type=style&index=0&id=79d17fc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d17fc4"]])

export default __exports__